/*
 * inline-atc.js — Bleached Renaissance
 * Tappable size buttons on the "Pairs well with" / "You may also like" cards.
 * Selecting a size sets the hidden [name=id] and enables Add. The Add button is a
 * real submit inside Dawn's <product-form>, so the theme's product-form.js handles
 * the AJAX add + opens the cart drawer. No custom cart logic.
 */
(function () {
  if (customElements.get('inline-atc')) return;

  class InlineATC extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('.inatc__id');
      this.addBtn = this.querySelector('.inatc__add');
      this.addText = this.querySelector('.inatc__add-text');
      this.sizes = Array.from(this.querySelectorAll('.inatc__size'));

      if (!this.sizes.length) return; // single-variant: Add already usable

      this._defaultText = this.addBtn ? this.addBtn.getAttribute('data-default-text') : '';

      this.sizes.forEach((btn) => {
        if (btn.hasAttribute('disabled')) return;
        btn.addEventListener('click', () => this.selectSize(btn));
      });

      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => {
          if (this.addBtn.hasAttribute('disabled')) return;
          this._confirmAfterAdd();
        });
      }
    }

    selectSize(btn) {
      this.sizes.forEach((b) => b.classList.remove('inatc__size--active'));
      btn.classList.add('inatc__size--active');
      if (this.idInput) {
        this.idInput.value = btn.getAttribute('data-variant-id');
        this.idInput.removeAttribute('disabled');
      }
      if (this.addBtn) {
        this.addBtn.removeAttribute('disabled');
        if (this.addText && this._defaultText) this.addText.textContent = this._defaultText;
      }
    }

    _confirmAfterAdd() {
      const btn = this.addBtn;
      const text = this.addText;
      if (!btn || !text) return;
      const original = text.textContent;
      let tries = 0;
      const check = setInterval(() => {
        tries++;
        const busy = btn.classList.contains('loading') || btn.getAttribute('aria-disabled') === 'true';
        if (!busy || tries > 40) {
          clearInterval(check);
          text.textContent = btn.getAttribute('data-added-text') || 'Added';
          setTimeout(() => { text.textContent = original; }, 1600);
        }
      }, 50);
    }
  }

  customElements.define('inline-atc', InlineATC);
})();